function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.35355 7.67427C4.15829 7.47901 3.84171 7.47901 3.64645 7.67427L0.464466 10.8563C0.269204 11.0515 0.269204 11.3681 0.464466 11.5634C0.659728 11.7586 0.97631 11.7586 1.17157 11.5634L4 8.73493L6.82843 11.5634C7.02369 11.7586 7.34027 11.7586 7.53553 11.5634C7.7308 11.3681 7.7308 11.0515 7.53553 10.8563L4.35355 7.67427ZM4.5 15.4018L4.5 8.02783L3.5 8.02783L3.5 15.4018L4.5 15.4018Z",
  fill: "#636363"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.64645 19.6592C3.84171 19.8545 4.15829 19.8545 4.35355 19.6592L7.53553 16.4773C7.7308 16.282 7.7308 15.9654 7.53553 15.7702C7.34027 15.5749 7.02369 15.5749 6.82843 15.7702L4 18.5986L1.17157 15.7702C0.976311 15.5749 0.659728 15.5749 0.464466 15.7702C0.269204 15.9654 0.269204 16.282 0.464466 16.4773L3.64645 19.6592ZM3.5 8.89539L3.5 19.3057H4.5L4.5 8.89539H3.5Z",
  fill: "#636363"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 11.374,
  y: 8.02783,
  width: 21.2544,
  height: 11.2778,
  fill: "#636363"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M33.3535 4.35355C33.5488 4.15829 33.5488 3.84171 33.3535 3.64645L30.1715 0.464466C29.9763 0.269203 29.6597 0.269204 29.4644 0.464466C29.2692 0.659728 29.2692 0.97631 29.4644 1.17157L32.2929 4L29.4644 6.82843C29.2692 7.02369 29.2692 7.34027 29.4644 7.53553C29.6597 7.7308 29.9763 7.7308 30.1715 7.53553L33.3535 4.35355ZM18.7787 4.5L33 4.5L33 3.5L18.7787 3.5L18.7787 4.5Z",
  fill: "#636363"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8965 3.64645C10.7012 3.84171 10.7012 4.15829 10.8965 4.35355L14.0785 7.53553C14.2738 7.7308 14.5903 7.7308 14.7856 7.53553C14.9809 7.34027 14.9809 7.02369 14.7856 6.82843L11.9572 4L14.7856 1.17157C14.9809 0.976311 14.9809 0.659728 14.7856 0.464466C14.5903 0.269204 14.2738 0.269204 14.0785 0.464466L10.8965 3.64645ZM31.3271 3.5H11.2501L11.2501 4.5H31.3271L31.3271 3.5Z",
  fill: "#636363"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6104 17V11.873H15.6113L15.7627 12.6152C16.2217 12.1204 16.7734 11.873 17.418 11.873C18.0625 11.873 18.5036 12.1074 18.7412 12.5762C19.2653 12.1074 19.8138 11.873 20.3867 11.873C21.5651 11.873 22.1543 12.5225 22.1543 13.8213V17H20.8604V13.7725C20.8604 13.2028 20.6032 12.918 20.0889 12.918C19.7048 12.918 19.3353 13.0905 18.9805 13.4355V17H17.6865V13.7871C17.6865 13.2077 17.4489 12.918 16.9736 12.918C16.596 12.918 16.2396 13.0905 15.9043 13.4355V17H14.6104ZM24.6738 10.0176V11.043H23.3799V10.0176H24.6738ZM24.6738 11.873V17H23.3799V11.873H24.6738ZM25.8994 17V11.873H26.9004L27.0615 12.625C27.5531 12.1237 28.113 11.873 28.7412 11.873C29.9554 11.873 30.5625 12.5046 30.5625 13.7676V17H29.2686V13.7676C29.2686 13.2012 28.987 12.918 28.4238 12.918C28.0039 12.918 27.5938 13.0856 27.1934 13.4209V17H25.8994Z",
  fill: "black"
});

function SvgMinOlculer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinOlculer);
export default __webpack_public_path__ + "static/media/min_olculer.785821a1.svg";
export { ForwardRef as ReactComponent };